import { useFormikContext } from 'formik';
import { useEffect, memo, useRef } from 'react';
const FormikOnChange = (props) => {
    const { onChange = () => null, enableValidation = true } = props;
    const oldValuesRef = useRef({});
    const { values, errors, setTouched, initialValues } = useFormikContext();
    useEffect(() => {
        const isNewValue = JSON.stringify(values) !== JSON.stringify(initialValues);
        if (isNewValue) {
            if (enableValidation) {
                if (Object.keys(errors).length === 0 &&
                    JSON.stringify(oldValuesRef.current) !== JSON.stringify(values)) {
                    onChange(values);
                }
                else {
                    setTouched(errors);
                }
            }
            else {
                onChange(values);
            }
        }
        oldValuesRef.current = values;
    }, [values, enableValidation, errors, onChange, setTouched, initialValues]);
    return null;
};
export default memo(FormikOnChange);
